<div class="skeleton-container">
  <p-skeleton width="20%" height="0.8rem" />
  <p-skeleton
    width="100%"
    height="2.5rem"
    [style]="{ 'margin-bottom': '20px' }"
  />

  <p-skeleton width="30%" height="0.8rem" />
  <p-skeleton
    width="100%"
    height="2.5rem"
    [style]="{ 'margin-bottom': '20px' }"
  />

  <p-skeleton width="20%" height="0.5rem" />
  <p-skeleton
    width="100%"
    height="2.5rem"
    [style]="{ 'margin-bottom': '20px' }"
  />

  <p-skeleton width="30%" height="0.5rem" />
  <p-skeleton
    width="100%"
    height="2.5rem"
    [style]="{ 'margin-bottom': '20px' }"
  />

  <p-skeleton width="20%" height="0.5rem" />
  <p-skeleton
    width="100%"
    height="2.5rem"
    [style]="{ 'margin-bottom': '20px' }"
  />

  <p-skeleton width="20%" height="0.5rem" />
  <p-skeleton
    width="100%"
    height="2.5rem"
    [style]="{ 'margin-bottom': '20px' }"
  />

  <p-skeleton width="30%" height="3rem" [style]="{ 'margin-left': 'auto' }" />
</div>
